@import '@hevoio/hevo-ui-toolkit/styles/variables';

.connectorContainer {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 650px;
  max-width: 60%;
}

.setupGuideDocs {
  width: 40%;
  flex-shrink: 0;
}

.noItemBox {
  margin: 0;
  max-width: 430px;
}
